import { Box, Flex } from '@rebass/grid';
import { breakpoints, styled } from 'styles';

export const Container = styled(Flex)`
  margin-bottom: 10px;

  @media (max-width: ${breakpoints.md}) {
    display: block;
  }
`;

export const AppBannerWrapper = styled(Box)`
  margin-top: 10px;

  @media (max-width: ${breakpoints.sm}) {
    display: none;
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  left: 15px;
  top: 15px;
`;

export const MarketDataContainer = styled(Flex)`
  flex-basis: 300px;
`;
